/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lost_Crazy_Larva_TwirlInputs */

const fr_lost_crazy_larva_twirl = /** @type {(inputs: Lost_Crazy_Larva_TwirlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un produit sur Stripe`)
};

/**

* @param {Lost_Crazy_Larva_TwirlInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lost_crazy_larva_twirl = /** @type {((inputs?: Lost_Crazy_Larva_TwirlInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lost_Crazy_Larva_TwirlInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lost_crazy_larva_twirl(inputs)
});